import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      e.preventDefault();
      if (href.startsWith('http')) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        const target = document.querySelector(href);
        target?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-brand-neon text-black font-bebas text-2xl md:text-3xl tracking-wide py-4 px-8 rounded-sm uppercase shadow-[0_0_15px_rgba(200,255,0,0.4)] hover:shadow-[0_0_25px_rgba(200,255,0,0.6)] transition-shadow duration-300 animate-pulse-glow cursor-pointer ${className}`} {...props} data-id="element-186">
      {children}
    </motion.button>;
}